import styled from 'styled-components'

export const Submit = styled.div`
	margin-top: 67px;

	@media only screen and (max-width: 800px) {
		margin-top: 40px;
	}
`
